export function cx(...inputs) {
    const out = [];
    for (const input of inputs) {
        if (!input)
            continue;
        if (typeof input === "string" || typeof input === "number") {
            out.push(String(input));
        }
        else if (Array.isArray(input)) {
            const nested = cx(...input);
            if (nested)
                out.push(nested);
        }
        else if (typeof input === "object") {
            for (const key in input) {
                if (input[key])
                    out.push(key);
            }
        }
    }
    return out.join(" ");
}
